// Enum -> display string maps (CONTRACT-BOUNDARY.md §1).
//
// Wire values are not display values. Two explicit sub-type maps are shipped
// (plural for filter chips, singular for the detail popover) — the singular is
// NEVER derived with `.replace(/s$/, '')`, which breaks on the first label that
// does not pluralise with a bare `s`.

import type {
  CalendarSource,
  CalendarSubType,
  KnownCalendarSource,
  ReminderOffset,
} from './typings'

export const SOURCE_LABELS: Record<KnownCalendarSource, string> = {
  sales_center: 'Sales Center',
  pestpac: 'PestPac',
  google: 'Google Calendar',
}

// Designed grey fallback — never renders `undefined` (MOCK-DATA.md §3).
export const UNKNOWN_SOURCE_LABEL = 'Other'

export function sourceLabel(source: CalendarSource): string {
  return SOURCE_LABELS[source as KnownCalendarSource] ?? UNKNOWN_SOURCE_LABEL
}

// "Activities" also covers plain SC events — merged into one chip (no
// separate "Events" chip in the design).
export const SUBTYPE_LABELS_PLURAL: Record<CalendarSubType, string> = {
  activity_reminder: 'Activities',
  next_action_date: 'Next Action Dates',
  expected_close_date: 'Expected Close Dates',
}

export const SUBTYPE_LABELS_SINGULAR: Record<CalendarSubType, string> = {
  activity_reminder: 'Activity Reminder',
  next_action_date: 'Next Action Date',
  expected_close_date: 'Expected Close Date',
}

export const REMINDER_LABELS: Record<ReminderOffset, string> = {
  at_time: 'At time of event',
  '1_hour_before': '1 hour before',
  '1_day_before': '1 day before',
}

export const NO_REMINDER_LABEL = 'No reminder'

// `null`/`undefined` (falsy `''` in the wire) maps to an explicit "none" label,
// never a bare empty string.
export function reminderLabel(
  offset: ReminderOffset | null | undefined,
): string {
  return offset ? REMINDER_LABELS[offset] : NO_REMINDER_LABEL
}
